import { render, staticRenderFns } from "./PasswordChangedDialog.vue?vue&type=template&id=756f3470&"
import script from "./PasswordChangedDialog.vue?vue&type=script&lang=ts&"
export * from "./PasswordChangedDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports